const revealTransitionDurationMs = 375;
const list = "_35slksuicj";
const item = "_35si18b9qxf";

export { item, list, revealTransitionDurationMs };
import "./_hints.style.linaria.module.css";
//# sourceMappingURL=_hints.style.js.map
